import { MeRerm } from 'packages/sdks-next/growp'
import { createContext } from 'react'
import { ModuleName } from './types'

type GatewayContextProps = {
  module: ModuleName
  setModule: (val: ModuleName) => void
  perms: MeRerm | null
}

export const GatewayContext = createContext<GatewayContextProps>({} as any)
